'use client'
import dynamic from 'next/dynamic'
import React, { useState, useEffect } from 'react'
// import ContactCardSent from '@components/ContactCardSent'
import { FaUser } from 'react-icons/fa'
import { MdOutlinePhoneIphone, MdEmail } from 'react-icons/md'
import { AiFillWechat } from 'react-icons/ai'
import { FaLine } from 'react-icons/fa'
import { RiArrowDropDownLine } from 'react-icons/ri'
// import { useSession } from 'next-auth/react'
import tailwindConfig from '@tailwind.config'
import { Combobox, Listbox } from "@headlessui/react"
import { countryCodes } from '@constants/countryCodes'
import { preferredContact } from '@constants/preferredContact';

const ContactCardSent = dynamic(() => import('@components/ContactCardSent'), {
    ssr: false,
})


const ContactCard = ({ property, dictionary, lang }) => {

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [userId, setUserId] = useState(null)
    const [contact, setContact] = useState(preferredContact[lang][0])
    const [phone, setPhone] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [line, setLine] = useState('')
    const [wechat, setWechat] = useState('')
    const [message, setMessage] = useState(`${dictionary.messagePrompt}`)
    const [hasEnquiry, setHasEnquiry] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState(countryCodes[0].code)
    const [query, setQuery] = useState('')

    const filteredCountries =
        query === ''
            ? countryCodes
            : countryCodes.filter((country) => {
                return country.country.toLowerCase().includes(query.toLowerCase()) || country.code.toLowerCase().includes(query.toLowerCase())
            })

    useEffect(() => {
        const setUserData = () => {
            const savedDetails = JSON.parse(localStorage.getItem('contactDetails'));

            if (savedDetails) {
                if (savedDetails.name && savedDetails.name !== '') {
                    setName(savedDetails.name);
                }
                if (savedDetails.selectedCountry && savedDetails.selectedCountry !== '') {
                    setSelectedCountry(savedDetails.selectedCountry);
                }
                if (savedDetails.phone && savedDetails.phone !== '') {
                    setPhone(savedDetails.phone);
                }
                if (savedDetails.email && savedDetails.email !== '') {
                    setEmail(savedDetails.email);
                }
                if (savedDetails.contact && savedDetails.contact !== '') {
                    setContact(savedDetails.contact);
                }
                if (savedDetails.line && savedDetails.line !== '') {
                    setLine(savedDetails.line);
                }
                if (savedDetails.wechat && savedDetails.wechat !== '') {
                    setWechat(savedDetails.wechat);
                }

            }
        }
        setUserData()
    }, [])

    const handleForm = async (e) => {
        e.preventDefault()

        setIsSubmitting(true)

        const contactDetails = {
            name,
            selectedCountry,
            phone,
            email,
            contact,
            line,
            wechat
        };

        localStorage.setItem('contactDetails', JSON.stringify(contactDetails));

        const { sendContactForm } = await import('@services/sendContactForm')
        const result = await sendContactForm({ userId, name, selectedCountry, phone, email, message, propertyId: property.id, agentId: property.agent, saleType: property.saleType, contact, line, wechat })
        if (result.ok) {
            setIsSubmitting(false)
            setHasEnquiry(true)
            const { sendGAEvent } = await import('@next/third-parties/google')

            sendGAEvent({ 
                event: "lead_inquiry",
                user_email: email || 'not_provided',
                user_phonecall: `${selectedCountry}${phone?.replace(/[a-zA-Z\W]/g, '')}`,
                property_id: property.id,
                property_name: property.name,
                property_type: property.metaCategory,
                property_location: property?.districts?.[0]?.subdistrictName?.['en'],
            })
        } else {
            setIsSubmitting(false)
        }
    }

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    return (
        <>
            {!hasEnquiry ? (
                <div className='xl:mb-0 pb-3 xl:border-b-0 border-b-[1px] border-b-forth'>
                    <div className='w-full border-[1px] p-2 border-secondary rounded-md'>
                        <h2 className='text-maincolor font-semibold text-xl mb-1'>{dictionary.title}</h2>
                        <form onSubmit={handleForm}>
                            <label className='text-secondary text-sm'>{dictionary.name}</label>
                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                <FaUser
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={28}
                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                />
                                <input
                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                    placeholder={dictionary.namePlaceholder}
                                    type='text'
                                    name='name'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <label className='text-secondary text-sm'>{dictionary.preferredContact}</label>
                            <Listbox value={contact} onChange={setContact}>
                                <div className='z-1 relative w-full cursor-default rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm" aria-label="Phone Dropdown">
                                        <span className="block truncate">{contact.name}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={32}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50" aria-label="Select Preferred Contact Method">
                                        {preferredContact[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                                aria-label={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.name}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                            {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                <>
                                    <label className='text-secondary text-sm'>{dictionary.phone}</label>
                                    <div className='flex flex-row w-full'>
                                        {/* <CountryCode className="w-1/4" /> */}
                                        <Combobox className="w-1/4"
                                            value={selectedCountry}
                                            onChange={setSelectedCountry}
                                        >
                                            <div className="relative w-full">
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={32}
                                                        />
                                                    </Combobox.Button>
                                                </div>
                                                <Combobox.Options
                                                    as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                    className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                    aria-label="Country Code Select"
                                                >
                                                    {filteredCountries.map((country) => (
                                                        <Combobox.Option
                                                            key={country.id}
                                                            value={country.code}
                                                            className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                        >
                                                            {country.code} {country.country}
                                                        </Combobox.Option>
                                                    ))}
                                                </Combobox.Options>
                                            </div>
                                        </Combobox>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <MdOutlinePhoneIphone
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.phonePlaceholder}
                                                required
                                                type='tel'
                                                inputMode="tel"
                                                pattern="^[0-9]{8,}$"
                                                name='phone'
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <>
                                            <label className='text-secondary text-sm'>{dictionary.email}</label>
                                            <div className='w-full'>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdEmail
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.email}
                                                        type='email'
                                                        name='email'
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </>
                                </>
                            )}
                            {(contact.value == 'line') && (
                                <>
                                    <label className='text-secondary text-sm'>{dictionary.line}</label>
                                    <div className='w-full py-1'>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <FaLine
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.linePlaceholder}
                                                type='line'
                                                name='line'
                                                value={line}
                                                onChange={(e) => setLine(e.target.value)}
                                                required
                                                aria-label="LINE ID Input"
                                            />
                                        </div>
                                        <>
                                            <label className='text-secondary text-sm'>{dictionary.phone}</label>
                                            <div className='flex flex-row w-full'>
                                                {/* <CountryCode className="w-1/4" /> */}
                                                <Combobox className="w-1/4"
                                                    value={selectedCountry}
                                                    onChange={setSelectedCountry}
                                                >
                                                    <div className="relative w-full">
                                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                            <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                                <RiArrowDropDownLine
                                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                                    size={32}
                                                                />
                                                            </Combobox.Button>
                                                        </div>
                                                        <Combobox.Options
                                                            as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                            className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                            aria-label="Country Code Select"
                                                        >
                                                            {filteredCountries.map((country) => (
                                                                <Combobox.Option
                                                                    key={country.id}
                                                                    value={country.code}
                                                                    className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                                >
                                                                    {country.code} {country.country}
                                                                </Combobox.Option>
                                                            ))}
                                                        </Combobox.Options>
                                                    </div>
                                                </Combobox>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdOutlinePhoneIphone
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.phonePlaceholder}s
                                                        type='tel'
                                                        inputMode="tel"
                                                        pattern="^[0-9]{8,}$"
                                                        minLength={8}
                                                        name='phone'
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        <>
                                            <label className='text-secondary text-sm'>{dictionary.email}</label>
                                            <div className='w-full'>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdEmail
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.email}
                                                        type='email'
                                                        name='email'
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'wechat') && (
                                <>
                                    <label className='text-secondary text-sm'>{dictionary.wechat}</label>
                                    <div className='w-full py-1'>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <AiFillWechat
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.wechatPlaceholder}
                                                type='wechat'
                                                name='wechat'
                                                value={wechat}
                                                onChange={(e) => setWechat(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <>
                                            <label className='text-secondary text-sm'>{dictionary.phone}</label>
                                            <div className='flex flex-row w-full'>
                                                {/* <CountryCode className="w-1/4" /> */}
                                                <Combobox className="w-1/4"
                                                    value={selectedCountry}
                                                    onChange={setSelectedCountry}
                                                >
                                                    <div className="relative w-full">
                                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                            <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                                <RiArrowDropDownLine
                                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                                    size={32}
                                                                />
                                                            </Combobox.Button>
                                                        </div>
                                                        <Combobox.Options
                                                            as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                            className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                            aria-label="Country Code Select"
                                                        >
                                                            {filteredCountries.map((country) => (
                                                                <Combobox.Option
                                                                    key={country.id}
                                                                    value={country.code}
                                                                    className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                                >
                                                                    {country.code} {country.country}
                                                                </Combobox.Option>
                                                            ))}
                                                        </Combobox.Options>
                                                    </div>
                                                </Combobox>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdOutlinePhoneIphone
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.phonePlaceholder}
                                                        type='tel'
                                                        inputMode="tel"
                                                        pattern="^[0-9]{8,}$"
                                                        minLength={8}
                                                        name='phone'
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        <>
                                            <label className='text-secondary text-sm'>{dictionary.email}</label>
                                            <div className='w-full'>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdEmail
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.email}
                                                        type='email'
                                                        name='email'
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'email') && (
                                <>
                                    <>
                                        <label className='text-secondary text-sm'>{dictionary.email}</label>
                                        <div className='w-full'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdEmail
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.email}
                                                    type='email'
                                                    name='email'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </>
                                    <>
                                        <label className='text-secondary text-sm'>{dictionary.phone}</label>
                                        <div className='flex flex-row w-full'>
                                            {/* <CountryCode className="w-1/4" /> */}
                                            <Combobox className="w-1/4"
                                                value={selectedCountry}
                                                onChange={setSelectedCountry}
                                            >
                                                <div className="relative w-full">
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                            <RiArrowDropDownLine
                                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                                size={32}
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Combobox.Options
                                                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                        className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                        aria-label="Country Code Select"
                                                    >
                                                        {filteredCountries.map((country) => (
                                                            <Combobox.Option
                                                                key={country.id}
                                                                value={country.code}
                                                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                            >
                                                                {country.code} {country.country}
                                                            </Combobox.Option>
                                                        ))}
                                                    </Combobox.Options>
                                                </div>
                                            </Combobox>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdOutlinePhoneIphone
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.phonePlaceholder}
                                                    type='tel'
                                                    inputMode="tel"
                                                    pattern="^[0-9]{8,}$"
                                                    minLength={8}
                                                    name='phone'
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </>
                                </>
                            )}
                            <label className='text-secondary text-sm'>{dictionary.message}</label>
                            <div className='w-full py-1'>
                                <textarea
                                    className='w-full border-[1px] border-forth text-secondary rounded-md p-2'
                                    placeholder='Please enter your question on request'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    rows={3}
                                    required
                                />
                            </div>
                            <button
                                disabled={isSubmitting}
                                className="w-full p-2 bg-third text-light font-bold rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] flex justify-center items-center"
                                type="submit"
                                >
                                {isSubmitting ? (
                                    <div className="w-5 h-5 border-2 border-light border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    dictionary.send
                                )}
                            </button>
                        </form>
                    </div>
                </div>) : (
                <ContactCardSent enquiryId={property.enquiryId} propertyId={property.id} email={email} dictionary={dictionary} lang={lang} />
            )}
        </>
    )
}

export default ContactCard